module.exports = __webpack_public_path__ + "static/img/jxlogo.650fa37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/jxlogo.png
// module id = /A1I
// module chunks = 0